import { z } from 'zod/v4'

export interface FetchCampaignContractAcceptationRequest {
  campaignId: number
  campaignContractAcceptationId: string
}

//TODO - 等 contract-editor 那邊有要重構再補完，先偷懶用 looseObject
export const campaignContractAcceptationSchema = z.looseObject({
  content: z.string(),
  contractable_id: z.number(),
  contractable_type: z.enum([
    'campaign_kol_labor_declaration',
    'campaign_kol_contract',
  ]),
})
export type CampaignContractAcceptation = z.infer<
  typeof campaignContractAcceptationSchema
>
